module.exports = __webpack_public_path__ + "images/emoji/copyright.06b12068658efa7740d5.png";